export class BackupPolicyGroupCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "LogicalOperator",
            "format": ""
        },
        {
            "name": "operands",
            "baseName": "operands",
            "type": "Array<BackupPolicyExpression>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPolicyGroupCondition.attributeTypeMap;
    }
    constructor() {
    }
}
